export const CARS_CATEGORY_BANNERS = {
    LISTING_PAGE: 'LISTING_PAGE',
    CALL_CUSTOMER_CARE: 'CALL_CUSTOMER_CARE'
};
